import { all, takeEvery } from 'redux-saga/effects';

import * as assetsSagas from 'sagas/assets';
import calendarSagas from 'sagas/calendar';
import * as dashboardSagas from 'sagas/dashboard';
import * as eventsSagas from 'sagas/events';
import * as exercisesSagas from 'sagas/exercises';
import * as favoritesSagas from 'sagas/favorites';
import loginSagas from 'sagas/login';
import * as mySuccessSagas from 'sagas/mySuccess';
import * as poolsSagas from 'sagas/pools';
import * as profileSagas from 'sagas/profile';
import * as programFeedViewSagas from 'sagas/programFeedView';
import * as programItemsSagas from 'sagas/programItems';
import * as programOverviewSagas from 'sagas/programOverview';
import * as programPreviewSagas from 'sagas/programPreview';
import * as programsSagas from 'sagas/programs';
import * as settingsSagas from 'sagas/settings';
import * as trackingSagas from 'sagas/trackingDescription';
import * as translationSagas from 'sagas/translation';
import * as tutorialSagas from 'sagas/tutorial';
import * as viewSagas from 'sagas/view';

import { actionTypes as assetsAT } from 'store/assets';
import { actionTypes as dashboardAT } from 'store/dashboard';
import { actionTypes as eventsAT } from 'store/events';
import { actionTypes as exercisesAT } from 'store/exercises';
import { actionTypes as favoritesAT } from 'store/favorites';
import { actionTypes as loginAT } from 'store/login';
import { actionTypes as mySuccessAT } from 'store/mySuccess';
import { actionTypes as optionalProgramItemsAT } from 'store/optionalProgramItems';
import { actionTypes as poolsAT } from 'store/pools';
import { actionTypes as profileAT } from 'store/profile';
import { actionTypes as programDaysAT } from 'store/programDays';
import { actionTypes as programItemsAT } from 'store/programItems';
import { actionTypes as programOverviewAT } from 'store/programOverview';
import { actionTypes as programPreviewAT } from 'store/programPreview';
import { actionTypes as programAT } from 'store/programs';
import { actionTypes as globalAT } from 'store/rootReducer';
import { actionTypes as settingsAT } from 'store/settings';
import { actionTypes as trackingAT } from 'store/trackingDescription';
import { actionTypes as transientPoolAT } from 'store/transientPoolState';
import { actionTypes as translationAT } from 'store/translation';
import { actionTypes as tutorialAT } from 'store/tutorial';
import { actionTypes as viewAT } from 'store/view';
import { Generator as ReduxGenerator } from 'types/Redux';

// function* logActions() {
// 	while (true) {
// 		const action = yield take(); // correct
// 		console.log(action);
// 	}
// }

export default function* rootSaga(): ReduxGenerator {
	yield all([
		loginSagas(),
		calendarSagas(),

		// takeEvery('*', logActions),

		/* Assets */
		takeEvery(assetsAT.LOAD_ASSET, assetsSagas.loadAsset),

		/* Translations */
		takeEvery(translationAT.RESOLVE, translationSagas.loadTranslation),

		/* Tutorials */
		takeEvery(loginAT.LOGIN_STATUS_KNOWN, tutorialSagas.loadTutorials),
		takeEvery(tutorialAT.UPDATE_TUTORIAL_FLAG, tutorialSagas.resolveTutorial),
		takeEvery(tutorialAT.TRIGGER_TUTORIAL, tutorialSagas.triggerTutorial),

		/* Tracking Guides */
		takeEvery(trackingAT.LOAD, trackingSagas.loadTrackingDescriptions),

		/* View Change */
		takeEvery(viewAT.CHANGE_VIEW_ID as any, viewSagas.changeViewID),

		/* Asynchron Events */
		takeEvery(eventsAT.REQUEST_ASYNC_EVENTS, eventsSagas.loadAsyncEvents),

		/* Custom Overlays */
		takeEvery(eventsAT.REQUEST_CUSTOM_OVERLAYS, eventsSagas.loadCustomOverlays),
		takeEvery(loginAT.LOGIN_STATUS_KNOWN, eventsSagas.loadCustomOverlays),
		takeEvery(eventsAT.REQUEST_SAVE_CUSTOM_OVERLAY_SHOWN, eventsSagas.saveCustomOverlayShown),

		/* Exercises */
		takeEvery(exercisesAT.REQUEST_EXERCISES, exercisesSagas.loadExercises),

		/* Pools */
		takeEvery(poolsAT.REQUEST_POOL, poolsSagas.getPool),
		takeEvery(transientPoolAT.REQUEST_SELECTED_ITEM, poolsSagas.loadSelectedPoolItem),

		/* Anamnesis */
		takeEvery(profileAT.REQUEST_USER_DATA, profileSagas.getUserData),
		takeEvery(profileAT.REQUEST_SAVE_COACH, profileSagas.saveCoach),
		takeEvery(profileAT.REQUEST_SAVE_GENDER, profileSagas.saveGender),
		takeEvery(profileAT.REQUEST_SAVE_AGE, profileSagas.saveAge),
		takeEvery(profileAT.REQUEST_SAVE_HEIGHT, profileSagas.saveHeight),
		takeEvery(profileAT.REQUEST_SAVE_WEIGHT, profileSagas.saveWeight),
		takeEvery(profileAT.REQUEST_SAVE_HEALTH_TARGET, profileSagas.saveHealthTarget),
		takeEvery(profileAT.REQUEST_SAVE_ACCEPT_HEALTH_TARGET, profileSagas.saveAcceptHealthTarget),
		takeEvery(profileAT.REQUEST_SAVE_DIETARY_HABITS, profileSagas.saveDietaryHabits),
		takeEvery(profileAT.REQUEST_SAVE_ACTIVITY_LEVEL, profileSagas.saveActivityLevel),
		takeEvery(profileAT.REQUEST_SAVE_DSGVO, profileSagas.saveDsgvo),
		takeEvery(profileAT.REQUEST_FINISH_ANAMNESIS, profileSagas.finish),
		takeEvery(profileAT.REQUEST_SAVE_SLOGAN, profileSagas.putSlogan),

		/* Other Profile Stuff */
		takeEvery(profileAT.REQUEST_FINISH_ONBOARDING, profileSagas.finishOnboarding),
		takeEvery(profileAT.REQUEST_SAVE_PARTICIPATE_COMPETITION, profileSagas.saveParticipateCompetition),

		/* Favorites */
		takeEvery(favoritesAT.REQUEST_FAVORITES_DATA, favoritesSagas.loadFavoritesData),
		takeEvery(favoritesAT.REQUEST_SELECTED_FAVORITE_DATA, favoritesSagas.loadSelectedFavoritesData),

		/* Settings for notifications etc. */
		takeEvery(settingsAT.REQUEST_UPDATE_SETTINGS, settingsSagas.updateSettings),

		/* Today Feed View */
		takeEvery(viewAT.REQUEST_VIEW, programFeedViewSagas.loadProgramFeedView),
		takeEvery(programDaysAT.CHANGE_CURRENT_DAY, programFeedViewSagas.loadProgramFeedDay),

		/* mySuccess View */
		takeEvery(mySuccessAT.REQUEST_MY_SUCCESS, mySuccessSagas.loadHallOfFame),
		takeEvery(mySuccessAT.REQUEST_MY_SUCCESS_LEVELS, mySuccessSagas.loadLevels),

		/* Cards */
		takeEvery(programAT.REQUEST_FINISH_MANUALLY, programsSagas.finishProgramManually),
		takeEvery(programItemsAT.REQUEST_COMPLETED, programItemsSagas.putCompleted),
		takeEvery(programItemsAT.REQUEST_WORKOUT_COMPLETED, programItemsSagas.putWorkoutCompleted),
		takeEvery(
			programItemsAT.REQUEST_WORKOUT_REPLACE_WITH_CUSTOM,
			programItemsSagas.postReplaceWorkoutWithCustomItem
		),
		takeEvery(programItemsAT.REQUEST_WORKOUT_CUSTOM_UPDATED, programItemsSagas.putWorkoutCustomItemUpdate),
		takeEvery(programItemsAT.REQUEST_CLOSE, programItemsSagas.putClose),
		takeEvery(programItemsAT.REQUEST_SLOGAN, programItemsSagas.putSlogan),
		takeEvery(programItemsAT.REQUEST_SAVE_TRACKING, programItemsSagas.postTracking),
		takeEvery(programItemsAT.REQUEST_UPDATE_TRACKING, programItemsSagas.putTracking),
		takeEvery(programItemsAT.REQUEST_TOGGLE_FAVORITE, programItemsSagas.toggleFavorite),
		takeEvery(programItemsAT.REQUEST_SWAP_ITEM, programItemsSagas.swapProgramItem), // used for pool feature
		takeEvery(
			programItemsAT.REQUEST_WORKOUT_CUSTOM_UPDATED_AND_COMPLETE,
			programItemsSagas.putWorkoutCustomUpdateAndComplete
		),

		/* Postpone feature */
		takeEvery(programItemsAT.REQUEST_MOVE_ITEM, programItemsSagas.postMoveItem),

		/* Optional items */
		takeEvery(optionalProgramItemsAT.REQUEST_LOAD_ITEM, programItemsSagas.loadOptionalItem),
		takeEvery(optionalProgramItemsAT.REQUEST_CREATE_ITEM, programItemsSagas.createOptionalItem),
		takeEvery(optionalProgramItemsAT.REQUEST_CREATE_CUSTOM, programItemsSagas.createCustomOptionalItem),

		/* Refetch Finish Program stats when Items are completed
		 * - don't just use the fetchActiveProgram Helper, because we need to only fetch the stats i.e. remaining todo's
		 * - if we fetch the whole program after the last item, has been checked, the summary would not show
		 */
		takeEvery(
			[
				programItemsAT.REQUEST_COMPLETED_SUCCESS,
				programItemsAT.REQUEST_WORKOUT_COMPLETED_SUCCESS,
				programItemsAT.REQUEST_CLOSE_SUCCESS,
				programItemsAT.REQUEST_SLOGAN_SUCCESS,
				programItemsAT.REQUEST_SAVE_TRACKING_SUCCESS,
			],
			programsSagas.refetchFinishProgramButton
		),

		/* Program Flushing */
		takeEvery(globalAT.FLUSH_ALL_PROGRAM_DATA, programsSagas.flushAllProgramData),

		/* Program Overview */
		takeEvery(programOverviewAT.LOAD, programOverviewSagas.loadProgramOverview),

		/* Program Preview */
		takeEvery(programPreviewAT.LOAD, programPreviewSagas.loadProgramPreview),
		takeEvery(programPreviewAT.START, programPreviewSagas.startProgram),
		takeEvery(programPreviewAT.OVERWRITE, programPreviewSagas.overwriteProgram),
		takeEvery(programPreviewAT.REPLACE, programPreviewSagas.replaceProgram),

		/* Dashboard */
		takeEvery(dashboardAT.REQUEST_DASHBOARD, dashboardSagas.loadDashboard),
		takeEvery(dashboardAT.REQUEST_DASHBOARD_MEASUREMENT, dashboardSagas.loadDashboardMeasurement),
		takeEvery(dashboardAT.REQUEST_SAVE_DASHBOARD_MEASUREMENT, dashboardSagas.postDashboardMeasurement),
		takeEvery(dashboardAT.REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM, dashboardSagas.loadDashboardMeasurementDiagram),
	]);
}
